import PublicTeacherArticlesTable from "./PublicTeacherArticlesTable";
export default PublicTeacherArticlesTable;
